module.exports = __webpack_public_path__ + "static/logo-16a9dfc8cdbe0e138823792c00bf43ed.png";